import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Breadcrumb({ titlePage, subTitle }) {
    const navigate = useNavigate();
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;
    
        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };
    
        // Follow initial height header
        updateHeight();
    
        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);
    
        // Follow resize window
        window.addEventListener('resize', updateHeight);
    
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    return (
        <div className="bres-cus" 
            style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
            <div className="container">
                <ul>
                    <li>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            navigate('/')
                        }}><img src="/images/icon-home.png" alt="" /></a>
                    </li>
                    <li className="dash">\</li>
                    <li>{titlePage}</li>
                    {subTitle && <>
                        <li className="dash">\</li>
                        <li>{subTitle}</li>
                    </>}
                </ul>
            </div>
        </div>
    )
}
